<div class="row h550">

  <div class="col-md-6 h500">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">

      <div class="box-header text-center">
        <h3 class="box-title ">Funcionários Cadastrados</h3><br />
        <span class="text-muted">Selecione para editar</span>

        <div class="divider"></div>

        <div class="input-group input-group-sm">
          <input type="text" class="form-control" #parametro id="parametro"
            placeholder="busca (matrícula ou nomes: funcionario, empreiteira, categoria)" maxlength="30">
          <div class="input-group-append">
            <button class="btn btn-light" type="button" (click)="search(parametro.value)" title="buscar"><i
                class="fa fa-search pr-1 pl-1"></i></button>
          </div>
          <div class="input-group-append">
            <button class="btn btn-light" type="button" title="limpar/remover filtro" (click)="clearSearch()"><i
                class="fa fa-times pr-1 pl-1"></i></button>
          </div>
        </div>

      </div>

      <div class="box-body h350">

        <div class="bx-tb-default-t1 pre-scrollable h300">
          <table class="table table-bordered table-hover">
            <thead class="thead-default">
              <tr >
                <th class="text-center" *ngIf="this.empreiteiras.length > 1">Empreiteira</th>
                <th class="text-center"><i *ngIf="this.isLoading" class="fa fa-spinner fa-spin fa-fw pull-left"></i>Id</th>
                <th class="text-center">Nome Funcionário</th>
              </tr>
            </thead>
            <tbody class="tbody-default">
              <tr *ngFor="let c of cadastrados" class="cp" (click)="getById(c.id)"
                [ngClass]="{'tr-info': c.id == this.form.get('id').value}">
                <td class="text-center" *ngIf="this.empreiteiras.length > 1">{{ c.empreiteiraStr }}</td>
                <td class="text-center">{{ c.id }}</td>
                <td>{{ c.nome }}</td>
              </tr>
              <tr *ngFor="let v of this.voids">
                <td></td>
                <td></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="box-footer">
        <span class="pl-1">Total: <b>{{ this.cadastrados?.length }}</b> </span>
        <span *ngIf="this.isFiltered" class="pl-3 text-primary">(filtrados)</span>
      </div>
    </div>
  </div>



  <div class="col-md-6">
    <div class="box bord" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }"
      style="height: 523px;">

      <div class="box-body" style="height: 433px;">

        <form novalidate style="padding-top: 20px;" [formGroup]="form" id="form" (validSubmit)="submit()">

          <div class="form-row" *ngIf="this.empreiteiras.length > 1">
            <div class="col-md-1"></div>
            <div class="col-md-6">
              <div class="position-relative form-group">
                <label for="">Empreiteira</label>
                <select for="" class="form-control" formControlName="empreiteiraId">
                  <option value="" selected>selecione</option>
                  <option *ngFor="let f of this.empreiteiras"  [value]="f.id">{{ f.nome }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-1"></div>
            <div class="col-md-6">
              <div class="position-relative form-group">
                <label for="">Matrícula</label>
                <input class="form-control" formControlName="matricula" type="text" maxlength="7" required>
                <section *ngIf="!form.valid" class="form-text text-danger pl-2">
                  <small *ngIf="form.get('matricula').hasError('isNotUniqueMatricula')">Esta matrícula já está em
                    uso</small>
                </section>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-1"></div>
            <div class="col-md-10">
              <div class="position-relative form-group">
                <label for="">Nome</label>
                <input class="form-control" formControlName="nome" type="text" maxlength="40" required>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-1"></div>
            <div class="col-md-6">
              <div class="position-relative form-group">
                <label for="">Categoria</label>
                <select for="" class="form-control" formControlName="categoriaId">
                  <option value="">selecione</option>
                  <option *ngFor="let f of this.categorias" [value]="f.id">{{ f.nome }}</option>
                </select>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-1"></div>
            <div class="col-md-11">
              <div class="position-relative form-group">
                <div class="custom-checkbox custom-control">
                  <input formControlName="ehEngenheiro" class="form-check-input cp" type="checkbox">
                  <label class="form-check-label" for=""
                    [ngClass]="{'label-check' : this.form.get('ehEngenheiro').value == true}">Pode ser informado na seleção de <b>Engenheiro</b> responsável </label>
                </div>
              </div>
            </div>
          </div>

          <div class="form-row">
            <div class="col-md-1"></div>
            <div class="col-md-11">
              <div class="position-relative form-group">
                <div class="custom-checkbox custom-control">
                  <input formControlName="ehEncarregado" class="form-check-input cp" type="checkbox">
                  <label class="form-check-label" for=""
                    [ngClass]="{'label-check' : this.form.get('ehEncarregado').value == true}">Pode ser informado na seleção de <b>Responsável OS</b></label>
                </div>
              </div>
            </div>
          </div>



        </form>

      </div>
      <div class="text-center">
        <app-ball-pulse *ngIf="isProcessing"></app-ball-pulse>
      </div>



    </div>

  </div>
</div>

<div class="row mt-3">
  <div class="col-md-12">
    <div class="box" [ngClass]="{'box-primary': !this.isEditing, 'box-warning': this.isEditing }">
      <div class="box-body">
        <div class="row">
          <div class="col-md-4">
            <div class="d-flex justify-content-start">
              <button type="button" class="btn btn-light pl-3 pr-3 mr-3"
                [disabled]="!(this.isEditing && this.autorizacoes?.podeExcluir)" title="Exluir funcionário selecionado"
                (click)="showModalSm(modaldelete)">
                <span class="text-danger"><i class="fa fa-trash"></i></span><span class="pl-3">Excluir</span>
              </button>
            </div>
          </div>
          <div class="col-md-4">
            <div class="d-flex justify-content-center">
              <a [routerLink]="['/home']" title="Tela Principal"><img src="./assets/images/homePeq.png" /></a>
            </div>
          </div>
          <div class="col-md-4">

            <div class="d-flex justify-content-end">

              <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="reset()">Limpar</button>
              <button type="submit" class="btn pl-5 pr-5 mr-3 btn-shadow" form="form"
                [disabled]="(!(!this.isEditing && this.autorizacoes?.podeIncluir) && !(this.isEditing && this.autorizacoes?.podeAlterar))"
                [ngClass]="{'btn-primary': !this.isEditing, 'btn-warning': this.isEditing }">
                <span *ngIf="!this.isEditing">Cadastrar</span>
                <span *ngIf="this.isEditing">Editar</span>
              </button>
            </div>

          </div>

        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #modaldelete let-c="close" let-d="dismiss">
  <div class="modal-header">
    <h4 class="modal-title">SIGEM CLOUD</h4>
  </div>
  <div class="modal-body">
    <div class="row">
      <div class="col-md-3">
        <div class="d-flex justify-content-center">
          <img src="assets\images\icon-question.png" />
        </div>
      </div>
      <div class="col-md-9">
        <div class="alert alert-warning">
          <div class="d-flex justify-content-center">
            <span class="question-modal pt-3 pb-3">Deseja excluir o <b>funcionário</b> selecionado?</span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="col-md-6"></div>
      <div class="col-md-6">
        <div class="d-flex justify-content-end">
          <button type="button" class="btn btn-light pl-5 pr-5 mr-3" (click)="c('Close click')">Não</button>
          <button type="button" class="btn btn-primary btn-shadow pl-5 pr-5 mr-2"
            (click)="delete(this.form.get('id').value, c)">Sim</button>
        </div>
      </div>
    </div>
  </div>
</ng-template>